import type { TOC } from '@ember/component/template-only';

interface Signature {
  Args: { data: Record<string, unknown> | null | undefined };
}

const PodcastDetail: TOC<Signature> = <template>
  {{#let (asPodcastData @data) as |d|}}
    <div class="flex flex-col gap-3">
      {{#if d.author}}
        <p class="text-base-content/80 text-sm font-medium">{{d.author}}</p>
      {{/if}}

      {{#if d.description}}
        <p
          class="text-base-content/70 line-clamp-3 text-sm"
        >{{d.description}}</p>
      {{/if}}

      <div class="flex flex-wrap gap-2">
        {{#if d.episodeCount}}
          <span class="badge badge-outline">{{d.episodeCount}} episodes</span>
        {{/if}}
        {{#if d.language}}
          <span
            class="badge badge-ghost badge-sm uppercase"
          >{{d.language}}</span>
        {{/if}}
        {{#each (topCategories d.categories) as |cat|}}
          <span class="badge badge-ghost badge-sm">{{cat}}</span>
        {{/each}}
      </div>

      {{#if d.feedUrl}}
        <div>
          <a
            href={{d.feedUrl}}
            target="_blank"
            rel="noopener noreferrer"
            class="btn btn-xs btn-outline"
          >
            RSS feed ↗
          </a>
        </div>
      {{/if}}
    </div>
  {{/let}}
</template>;

interface PodcastData {
  title?: string;
  author?: string;
  description?: string;
  artworkUrl?: string;
  feedUrl?: string;
  language?: string;
  episodeCount?: number;
  categories?: Record<string, string> | string[];
}

function asPodcastData(
  raw: Record<string, unknown> | null | undefined
): PodcastData {
  return raw ?? {};
}

function topCategories(
  cats: Record<string, string> | string[] | undefined
): string[] {
  if (!cats) return [];
  if (Array.isArray(cats)) return cats.slice(0, 4);
  return Object.values(cats).slice(0, 4);
}

export default PodcastDetail;
